var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar'),_c('div',{staticClass:"is-flex"},[_c('Sidebar'),_c('main',{staticClass:"page"},[(_vm.permissions)?_vm._t("default"):_vm._e()],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }